import { ORDER_TYPES } from '../constants.js'
import { joinUrl, omitUndefinedValues } from '../utils.js'
import { ENABLED_ASSETS, ROBINHOOD_REDIRECT_URL, ROBINHOOD_URL } from './constants.js'
import robinhoodAdapter from './adapter.js'

export const getWidgetUrl = async (
  {
    assets: assets_ = ENABLED_ASSETS,
    appId,
    finalUrl = ROBINHOOD_REDIRECT_URL,
    fromAmount,
    fromAsset,
    serverClient,
    toAsset = [],
    type = ORDER_TYPES.buy,
    url = ROBINHOOD_URL,
    userId,
    walletAddress,
  } = Object.create(null)
) => {
  if (!appId) {
    throw new Error('`appId` is required')
  }

  if (fromAmount && !fromAsset) {
    throw new Error('`fromAsset` is required when `fromAmount` is provided')
  }

  if (!toAsset || toAsset.length === 0) {
    throw new Error('`toAsset` is required')
  }

  if (!serverClient) {
    throw new Error('`serverClient` is required')
  }

  if (!ORDER_TYPES[type] || type === ORDER_TYPES.sell) {
    throw new Error(`Invalid order type "${type}"`)
  }

  if (!userId) {
    throw new Error('`userId` is required')
  }

  if (!walletAddress) {
    throw new Error('`walletAddress` is required')
  }

  const { connectId } = await serverClient.post('/auth/robinhood', {
    auth: true,
    data: {
      user_identifier: userId,
      withdrawal_address: walletAddress,
    },
    headers: {
      'application-id': appId,
    },
  })

  const [assetCode, network] = robinhoodAdapter.fromExodusToProviderAsset(toAsset[0], assets_)

  const searchParameters = new URLSearchParams(
    omitUndefinedValues({
      applicationId: appId,
      assetCode,
      connectId,
      fiatAmount: fromAmount,
      fiatCode: fromAsset,
      redirectUrl: finalUrl,
      supportedNetworks: network,
      userIdentifier: userId,
      walletAddress,
    })
  )

  return joinUrl(url, `?${searchParameters}`)
}
